module.exports = __webpack_public_path__ + "assets/img/facergt-interactive.2838a712.png";